import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578ab970"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "provinces" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shipping" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Free Shipping")
], -1))
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "cloud" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabs, (item, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: item,
          onClick: ($event: any) => ($setup.tabsItem(item,index)),
          class: _normalizeClass({'tabActives':$setup.tabsActive === index})
        }, _toDisplayString(item), 11, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.english, (item) => {
        return (_openBlock(), _createElementBlock("div", { key: item }, [
          _createElementVNode("span", null, _toDisplayString(item), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.address, (i, index) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: i.area_id
            }, [
              (i.area_name.slice(0,1) === item)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    onClick: ($event: any) => ($setup.region_fn(index,i)),
                    class: _normalizeClass({'activeColor':$setup.active === index})
                  }, [
                    _createTextVNode(_toDisplayString(i.area_name) + " ", 1),
                    _withDirectives(_createVNode(_component_van_icon, { name: "success" }, null, 512), [
                      [_vShow, $setup.active === index]
                    ])
                  ], 10, _hoisted_6))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}